// src/javascript/features/media-protection.ts
//
// Media download dissuasion.
// ONE delegated listener on `document` (covers Dawn lazy-load + dynamically
// injected media). Blocks the right-click "Save image/video as…" menu and the
// drag-to-desktop gesture on <img>/<video>, EXCEPT when the media sits inside an
// <a> (product cards stay openable in a new tab). Same exemption as the CSS
// (`a img, a video`). Purely a deterrent — assets remain reachable via the
// Network tab. contextmenu is NOT blocked globally: forms, text and the
// spellchecker keep their native menu (a11y).
function isProtectedMedia(target) {
    if (!(target instanceof Element))
        return false;
    const media = target.closest('img, video');
    if (!media)
        return false;
    // Exempt: media wrapped in a link.
    return !media.closest('a');
}
function onContextMenu(event) {
    if (isProtectedMedia(event.target))
        event.preventDefault();
}
function onDragStart(event) {
    if (isProtectedMedia(event.target))
        event.preventDefault();
}
function initMediaProtection() {
    document.addEventListener('contextmenu', onContextMenu);
    document.addEventListener('dragstart', onDragStart);
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMediaProtection);
}
else {
    initMediaProtection();
}
